module.exports = {
  slug: `humanrightsquiz`, // page slug, must not contain spaces
  title: `HOW HOT IS THE UK ON HUMAN RIGHTS? TAKE THE QUIZ NOW`, // page title
  meta: { // share copy
    title: `How hot is the UK on human rights? Take the quiz now >>`, // fb share title
    desc: `The truth might surprise you...`, // fb share description
    image: require(`../assets/humanrights_banner_mobile.jpg`), // fb share image
    whatsapp: `I got [SCORE] out of 6 on this Amnesty quiz... can you spot the UK's hidden hypocrisy and beat my score? 😡🔥 ` // whatsapp share text (don't add a link, we auto add this after)
  },
  header: { // This is the text you see at the top of the page on the first question
    title: `HOW HOT IS THE UK ON HUMAN RIGHTS?<br>TAKE THE QUIZ NOW`, // title text, you can add standard text formatting html tags in here (strong, i etc.) and also line breaks <br>, but nothing else.
    subtitle: `Can you spot the UK's hidden hypocrisy? The truth might surprise you...` // No html, just raw text
  },
  questions: [ // questions array, you can have as many question objects as you want
    {
      backgroundImage: require(`../assets/humanrights_q1.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q1_mobile.jpg`),
      question: `Is peaceful protest criminalised in the UK?`,
      answers: [
        `Yes, peaceful protests can be banned`,
        `No, only violent protests are illegal`,
      ],
      userAnswer: null,
      answer: 0,
      answerText: `Under the new Policing Act, the UK Government has extended restrictions on the right to protest, and can now ban peaceful protests if they might be ‘noisy’ or cause ‘annoyance’. The Act can also lead to prison sentences of up to 10 years for ordinary, non-violent acts of protest.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q2.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q2_mobile.jpg`),
      question: `Is a black person more likely than a white person to get stopped and searched by police in England and Wales?`,
      answers: [
        `Yes, 3x as likely`,
        `Yes, 7x as likely`,
        `No`
      ],
      userAnswer: null,
      answer: 1,
      answerText: `Black people are at least 7x more likely to be stopped and searched by police in England and Wales. The new Policing Act includes greater police powers to enhance stop and search, a tactic which is already used disproportionately against people of colour.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q3.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q3_mobile.jpg`),
      question: `Can LGBTI+ people receive 'conversion therapy' in the UK?`,
      answers: [
        `No, it was banned in 2003`,
        `It's illegal, but still exists`,
        `Yes, it's still not illegal in the UK`,
      ],
      userAnswer: null,
      answer: 2,
      answerText: `Conversion therapy is still not illegal in the UK. Shockingly, the recent draft bill to ban conversion therapy excludes trans and non-binary people. If it goes into effect like this, trans and non-binary people will not be protected against conversion therapy when the bill is made law.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q4.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q4_mobile.jpg`),
      question: `True or false? The UK Government can order people to be deported to places they’ve never been, even people who were born and raised in the UK.`,
      answers: [
        `True`,
        `False`,
      ],
      userAnswer: null,
      answer: 0,
      answerText: `The UK government can and does order the deportation of people born in the UK to countries they've never even visited. This happens even to people who have never left the UK and have rights to British citizenship.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q5.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q5_mobile.jpg`),
      question: `What has the UK contributed to the Saudi-led attacks that left millions of Yemeni people dead, homeless and starving?`,
      answers: [
        `£1.7 billion of aid to Yemen`,
        `£7.2 billion of weapons to Saudi Arabia`,
        `A peace deal via trade sanctions`,
      ],
      userAnswer: null,
      answer: 1,
      answerText: `Despite supporting Yemen with aid, the UK has sold £7.2 billion in weapons to Saudi Arabia during the conflict.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q6.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q6_mobile.jpg`),
      question: `Can a homeless person be arrested in the UK for being a rough sleeper?`,
      answers: [
        `Yes`,
        `No`,
      ],
      userAnswer: null,
      answer: 0,
      answerText: `Yes, police can arrest homeless people for sleeping on the streets. If a homeless person attempts to house themselves in a vehicle or empty building, they can be prosecuted for that as well.`
    },
    {
      backgroundImage: require(`../assets/humanrights_q7.jpg`),
      backgroundImageMob: require(`../assets/humanrights_q7_mobile.jpg`),
      question: `In the UK, are the police allowed to arrest and imprison people who are Gypsies, Roma, and Travellers (GRT), and confiscate their homes?`,
      answers: [
        `Yes, GRT can lose their homes and be imprisoned for up to three months`,
        `No, the UK government is required to provide suitable stopping places for GRT`,
        `No, GRT have had the right to roam for thousands of years`,
      ],
      userAnswer: null,
      answer: 0,
      answerText: `The Policing Act has created a new offence of ‘residing on land without consent, in or with a vehicle’. This allows the police to arrest people who are GRT, and confiscate their homes. There is currently no government provision for suitable stopping places for the GRT community, who now face three months in jail if they stop on an unauthorised site.`
    },
  ],
  signAsk: { // this is the petition ask page, comes directly after the questions (unless on /supporter in which case this and the petition page dont show)
    image: require(`../assets/humanrights_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_banner_mobile.jpg`), // switches to this when less than 768px wide
    title: `Before you get your results...`, // the title
    copy: `<p>The recently passed Policing Act will make it harder to stand up to power in the UK. Now the UK government is planning to further roll back our rights by scrapping the Human Rights Act.</p><p>The UK Government’s plans will make it more difficult for public bodies to uphold rights and for people to challenge decisions that violate their human rights. They want us to believe that they’re doing it for the greater good, but that couldn’t be further from the truth. In reality, it will give people in power MORE power, and make it much harder for people to hold them to account when they need to.</p><p>At Amnesty, we will be campaigning to stop this raid on our rights and protect our fundamental freedoms.</p>`, // this can be html, you should wrap each para in <p></p> to get proper styling
    question: `<p>Will you help us?</p>`, // this is the text/question that shows above the buttons, you should wrap each para in <p></p> to get proper styling
    yes_btn: `Yes, absolutely`, // standard string, shows on the button that goes to the petition
    no_btn: `No, sorry` // standard string, shows on the button that skips the petition and goes to the share ask
  },
  sign: { // petition page
    image: require(`../assets/humanrights_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_banner_mobile.jpg`), // switches to this when less than 768px wide
    title: `THAT’S GREAT, THANK YOU!`, // the title
    subTitle: `The Human Rights Act protects all of us, all of the time. It protects the most basic and important things – like freedom of expression, liberty and family life. These proposals must be scrapped, and the Human Rights Act safeguarded instead.`, // this shows under the main title
    subTitle_quote: true, // this decides whether you want it styling as a quote (adds quotation marks and modifies spacing)
    petitionTitle: `ADD YOUR NAME`, // this the large text like "ADD YOUR NAME", that shows above the iframe
    EN_URL: `https://actions.amnesty.org.uk/page/111784/petition/1` // this is the URL to the EN petition you want to embed
  },
  shareAsk: { // / results screen
    image: require(`../assets/humanrights_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_banner_mobile.jpg`), // switches to this when less than 768px wide
    imageAlt: require(`../assets/humanrights_care_homes_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMobAlt: require(`../assets/humanrights_care_homes_banner_mobile.jpg`), // switches to this when less than 768px wide
    question: `<p>Pretty shocking, right? Now will you challenge your friends to beat your score? It only takes 30 seconds to share...</p>`, // this is the text/question that shows above the buttons, you should wrap each para in <p></p> to get proper styling
    yes_btn: `Yes, I'll share`, // standard string, shows on the button that goes to the share slide
    no_btn: `No, sorry` // standard string, shows on the button that skips the share and goes to the donate slide
  },
  donateAsk: {
    image: require(`../assets/humanrights_donate.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_donate_mobile.jpg`), // switches to this when less than 768px wide
    title: `Before you go`, // the title
    copy: `<p>Humanity can't win without you. Can you chip in and help us fight even harder for human rights?</p>`, // this can be html, you should wrap each para in <p></p> to get proper styling
    yes_btn: `Yes, I'll chip in`, // standard string, shows on the button that goes to the donate link and scrolls to the thanks slide
    donate_link: `https://www.amnesty.org.uk/giving/donate/give-now-handraiser`, // this is the link the donate (yes) button goes to
    no_btn: `No, sorry` // standard string, shows on the button that skips the donate link and goes to the thanks slide
  },
  thanks: {
    image: require(`../assets/humanrights_banner.jpg`), // banner image, this can be the same as the mob one if you it doesn't rely on screen size
    imageMob: require(`../assets/humanrights_banner_mobile.jpg`), // switches to this when less than 768px wide
    title: `THANKS FOR TAKING THE QUIZ`, // the title
    copy: `<p>It highlights just some of the injustice that's happening right now in the UK.</p><p>If you want to help to build a world that's fairer for everyone, take a look at some of our most urgent campaigns today.</p>`, // this can be html, you should wrap each para in <p></p> to get proper styling
    btn_text: `SHOW ME URGENT CAMPAIGNS`, // this is the generic button at the end
    btn_link: `https://www.amnesty.org.uk/actions` // this is the link the button at the end goes to
  }
}